module.exports = __webpack_public_path__ + "static/media/icon-document-white.dc0844f9.svg";